import { MenuEngineeringProfitability } from './models';

export const getters = {
  menuRecommendation: (state) => state.menuRecommendation,
  menuRecommendationList: (state) => state.menuRecommendationList,
  isEngineeringProfitabilityLoading: (state) => state.isEngineeringProfitabilityLoading > 0,
  getSectionChangesByGuids: (state) => (sectionGuids = []) => {
    let sectionChanges = [];
    if (state.menuRecommendation) {
      sectionChanges = state.menuRecommendation.sections.reduce((changes, section) => {
        if (sectionGuids.includes(section.guid)) changes.push(section.getChange());
        return changes;
      }, []);
    }
    return sectionChanges;
  },

  menuEngineeringProfitabilityList: (state) => {
    if (state.periodEngineeringProfitability) return state.periodEngineeringProfitability.menuProfitabilityList;
    return [];
  },

  getSectionEngineeringProfitabilityList: (state, allGetters) => (menuGuid) => {
    const menuProfitability = allGetters.menuEngineeringProfitabilityList.find((m) => m.menuGuid === menuGuid);
    if (menuProfitability) return menuProfitability.sectionProfitabilityList;
    return [];
  },

  getMenuProfitability: (state, allGetters) => (menuGuid) => {
    const menuEngineeringProfitability = allGetters.menuEngineeringProfitabilityList.find((m) => m.menuGuid === menuGuid);
    return menuEngineeringProfitability || new MenuEngineeringProfitability();
  },

  getSectionProfitability: (state, allGetters) => (menuGuid, sectionGuid) => {
    const sectionList = allGetters.getMenuProfitability(menuGuid).sectionProfitabilityList;
    const sectionEngineeringProfitability = sectionList.find((s) => s.sectionGuid === sectionGuid);
    return sectionEngineeringProfitability;
  }
};
